import { uploadForm } from './state';

export default {
    updateUploadDialogOpen(state, payload) {
        state.uploadDialogOpen = payload;
    },

    updateIsSaving(state, payload) {
        state.isSaving = payload;
    },

    updateValidations(state, payload) {
        state.validations = payload;
    },

    updateFormData(state, payload) {
        state.formData = Object.assign({}, state.formData, payload);
    },

    resetFormData(state, payload) {
        state.formData = uploadForm();
    },

    updatePreviewImage(state, payload) {
        state.previewImage = payload;
    },

    updateFormRef(state, payload) {
        state.formRef = payload;
    }
}